<svelte:options
        customElement={{tag: "ft9-benefit-activation-slider-v1", props: {
            size: { type: "String" },
            isActivated: { type: "Boolean", attribute: "is-activated" },
            labelActivated: { type: "String", attribute: "label-activated"},
            labelDeactivated: { type: 'String', attribute: "label-deactivated"},
            withAnimation: { type: "Boolean", attribute: "with-animation" },
            }
        }}
/>

<script lang="ts">
    import type {ActivationSliderProps} from "./ActivationSliderProps.ts";
    import TouchSlider from "./TouchSlider.svelte";

    let containerEl: HTMLDivElement;
    let sliderEl: TouchSlider | null = $state(null);

    const {
        size = "large",
        isActivated = false,
        labelActivated = "Aktiviert",
        labelDeactivated = "Deaktiviert",
        withAnimation = false,
    }: ActivationSliderProps = $props();

    const emitActivation = () => {
        window.otto.ft9.benefit.components.activationSlider.activate.emit({
            /*                                                           */
            instance: $host() as HTMLElement,
        })
    }

    export const reset = () => {
        if (isActivated) {
            return;
        }

        sliderEl?.reset();
    }
</script>

<div class={["slider-container", `slider-container--${size}`]} bind:this={containerEl}>
    {#if isActivated}
    <button class="slider-wrapper activated" aria-checked="true" role="switch" disabled>
        <svg class="checked" xmlns="http:/*                  */
             viewBox="0 0 52 52">
            <circle class="checkmark-circle" cx="26" cy="26" r="27"/>
            <path class={[withAnimation && "checkmark-with-animation"]} fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
        </svg>
        <span class="slider-label activated">{labelActivated}</span>
    </button>
    {:else}
        <TouchSlider onchange={emitActivation} size={size} bind:this={sliderEl}>
            <span class="slider-label">{labelDeactivated}</span>
        </TouchSlider>
    {/if}
</div>

<style lang="scss" global>
    @use "activationSlider.scss";

</style>